import { render } from "./admin-modal.vue?vue&type=template&id=5a69f8fe"
import script from "./admin-modal.vue?vue&type=script&lang=js"
export * from "./admin-modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__